"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestUtil = void 0;
const PointLocator_js_1 = __importDefault(require("jsts/org/locationtech/jts/algorithm/PointLocator.js"));
const Location_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Location.js"));
class TestUtil {
    static IsPointInPolygon(point, polygon) {
        let pointLocator = new PointLocator_js_1.default();
        return pointLocator.locateInPolygon(point, polygon) === Location_js_1.default.INTERIOR;
    }
}
exports.TestUtil = TestUtil;
